import { AppStore, DownloadNodesAction } from '@alfresco/aca-shared/store';
import { DownloadZipDialogComponent } from '@alfresco/adf-core';
import { Component, EventEmitter, Inject, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

@Component({
  templateUrl: './download-all.dialog.html',
  styleUrls: ['./download-all.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DownloadAllDialog implements OnDestroy {
  onDestroy$: Subject<boolean> = new Subject<boolean>();

  /** Emitted when the set access point is successfully set
   */
  @Output()
  success: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private store: Store<AppStore>,
    private dialog: MatDialogRef<DownloadAllDialog>,
    private dialogZip: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  download(){
    if (this.data.selection?.count > 0) {
      this.store.dispatch(new DownloadNodesAction());
      this.dialog.close();
      return;
    }

    const nodeIds = this.data.nodeIds;
    this.dialog.close();
    if (nodeIds?.length > 0) {
      this.dialogZip.open(DownloadZipDialogComponent, {
        width: '600px',
        disableClose: true,
        data: { nodeIds }
      });
    }
  }
}
